<template>

    <div>
        <b-form-select 
            v-model="selected"
            :options="mappedOptions"
            @input="onSelect"
        >
            <option 
                value="null" 
                disabled
                selected
                hidden
            >
                {{ title }}
            </option>
        </b-form-select>
    </div>
</template>
<script>
export default {
    name: 'dropdown',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selected: null,
        }
    },
    computed: {
        mappedOptions() {
            return this.options
        }
    },
    methods: {
        onSelect(value) {
            this.$emit('select', value)
        }
    },
}
</script>
<style lang="scss">

</style>